import Backbone from 'backbone'
import _ from 'lodash'
import FormView from 'scoreboard/components/form-view'
import template from './constant-value-form.hbs'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import numericValidator from 'scoreboard/components/validators/numeric-validator'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import formHelper from 'scoreboard/components/form-helper'
import getAxisDataType from './get-axis-data-type'

/**
 * Prompts for a number value to use for a "Constant Number" reference line
 */
const ConstantValueForm = Backbone.View.extend({
	tagName: 'form',

	/**
	 * @type ChartDesigner
	 */
	model: null,

	initialize: function(options = {}) {
		this.axis = options.axis
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		this.$el.append(template())

		this.markedConstant = new MarkedField({
			el: this.$('.constant-number input'),
			validators: [ requiredValidator, numericValidator ],
			evaluator: numericEvaluator,
			dataType: getAxisDataType({ chart: this.model, axis: this.axis })
		}).render()

		this.formView.start()
	},

	submit: function() {
		const value = formHelper.readFromDom(this.el).constantNumber
		this.trigger('done', value)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this.markedConstant], 'remove')
	}
})

export default ConstantValueForm
ConstantValueForm.__filename__ = 'charts/edit/analytics/constant-value-form.js'
